import React, { memo, useMemo } from "react";
import { useForm } from "react-hook-form";
import { NodeProps } from "reactflow";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import { NodeData, NodeType } from "../../../models/nodeType";
import SelectTaskLocation from "../../base/SelectTaskLocation";
import { FlowNodeWithChildren } from "./FlowNode";

interface ShowTasks extends NodeData {
  taskLocation: string;
}

const ShowTasksNode: React.FC<NodeProps<NodeType<ShowTasks>>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const taskLocation = nodeData?.taskLocation ?? "";

  const { getValues, setValue, handleSubmit } = useForm<ShowTasks>({
    defaultValues: useMemo(
      () => ({
        taskLocation,
      }),
      [taskLocation]
    ),
    mode: "onBlur",
  });

  const { updateNodeData } = useUpdateNodeData<ShowTasks>(nodeId);

  return (
    <FlowNodeWithChildren {...props}>
      <form className={"nodrag"} onSubmit={handleSubmit(updateNodeData)} onBlur={handleSubmit(updateNodeData)}>
        <SelectTaskLocation color={color} value={getValues("taskLocation")} setValue={(value) => setValue("taskLocation", value)} />
      </form>
    </FlowNodeWithChildren>
  );
};

export default memo(ShowTasksNode);
